/* eslint-disable react/jsx-pascal-case */
import { connect } from 'react-redux';
import React from 'react';
import { RollbackOutlined } from '@ant-design/icons';
import AnalyticsRouter from '../../../routes/analyticsRoute';
const analytics_V1 = (props) =>{
  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
    let pathname = props.location.pathname;
    return (
      <div>
        {!pathname.includes('ModelsWorkbench') ? (
          <div>
            <div style={{ padding: '10px 19px' }}>
              <div >
                <span style={{ cursor: 'pointer' }} onClick={() => props.navigate(-1)}>
                  <RollbackOutlined />
                  {translation('Go Back')}
                </span>
              </div>
            </div>
            <AnalyticsRouter />
          </div>
        ) : (
          <AnalyticsRouter />
        )}
      </div>
    );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});
export default connect(mapStateToProps)(analytics_V1);
